import { userRole } from "../constant";

export const getFormatedUserType = (text) => {
  switch (text) {
    case userRole.admin:
      return "Site Admin";
    case userRole.installer:
      return "Installer";
    case userRole.user:
      return "Site User";
    case userRole.public:
      return "Public User";
    case userRole.businessAdmin:
      return "Business Admin";
    default:
      return "Super Admin";
  }
};
